import React, {useEffect, useState} from 'react';
import styles from './MachineActivityStatus.module.scss';
import {useDispatch, useSelector} from "react-redux";
import Modal from "../../miscellaneous/Modal/Modal";

import {$t} from "../../../helpers/translator";
import _ from "lodash";
import api from "../../../helpers/api";
import {setAlert} from "../../../store/alerts-slice";
import Loader from "../../miscellaneous/Loader/Loader";


const MachineActivityStatus = (props) => {
    // const dispatch = useDispatch();

    const [showModal, setShowModal] = useState(false)
    const [activityList, setActivityList] = useState(null)

    const routes = {
        init: '',
    }
    useEffect(() => {
        if(props.platform){
            getData();
        }
    }, [props.platform]);

    async function getData(){
        let res = await api.get(`platform/${props.platform.id}/logs`);

        // console.log('getData: ', res)
        if (!props.platform) {
            return;
        }

        if (!res || !res.data || !res.data.data) {
            return;
        }

        setActivityList(res.data.data);
    }

    function renderModalContent() {
        return (
            <div className={`${styles['container']}`}>
                <div className={'alma-box-header'}>
                    <div>
                        <h2>{$t('global.machines.machineActivityStatus')}</h2>
                    </div>
                </div>
                <div className={'alma-box-content'}>
                    <div className={'alma-field-container'}>
                        <table className={styles.table}>
                            <thead>
                                <tr>
                                    <th>Router</th>
                                    <th>Date</th>
                                    <th>Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                {activityList ? activityList.map((item, index) => {
                                    if (!item.route_name || !item.created_at) {
                                        return <div></div>
                                    }
                                    const realName = item.route_name.split("/")
                                    const splitDate = item.created_at.split(" ")
                                    return <tr className={styles.row} key={ index }>
                                        <td>{ $t(`global.machineActivity.${realName[realName.length - 1]}`) }</td>
                                        <td>{ splitDate[0] }</td>
                                        <td>{ splitDate[1] }</td>
                                    </tr>
                                })
                                : null}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }


    return (
        <div >

            <div className={styles.flexRow}>
            {props.userType === 5 ?
                <div className={'alma-button'}
                     onClick={() => setShowModal(true)}>{$t('global.machines.machineActivityStatus')}</div>
            : null
            }
            </div>

            <Modal content={renderModalContent()}
                   onClose={async () => {
                       setShowModal(false);
                   }}
                   visible={showModal}/>
        </div>
    );
}


export default MachineActivityStatus;
